import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const SelectPlan = () => {
  const navigate = useNavigate();
  
  const handleSelectPlan = (planId) => {
    if (planId === 'recruit') {
      toast.success('Welcome to CXrecon! You\'re on the Recruit plan.');
      navigate('/dashboard');
    } else {
      navigate('/manage-subscription');
    }
  };

  return (
    <div className="select-plan-container">
      <div className="select-plan-header">
        <h1>⚔️ Choose Your Command Tier</h1>
        <p>Select the plan that fits your reconnaissance mission</p>
      </div>

      <div className="pricing-cards three-tier">
        {/* Recruit Plan */}
        <div className="pricing-card">
          <div className="plan-badge free-badge">FREE</div>
          <h3>🎖️ Recruit</h3>
          <div className="price">
            <span className="amount">$0</span>
            <span className="period">/forever</span>
          </div>
          <ul className="features">
            <li>✓ 3 Active Surveys</li>
            <li>✓ Up to 10 Questions per Survey</li>
            <li>✓ 7-Day Survey Duration</li>
            <li>✓ AI Survey Generation</li>
            <li>✓ AI Summary Reports</li>
            <li>✓ CSV Export</li>
            <li>✓ Basic Analytics</li>
          </ul>
          <button 
            className="select-plan-btn"
            onClick={() => handleSelectPlan('recruit')}
          >
            Start Free
          </button>
        </div>
        
        {/* Sergeant Plan */}
        <div className="pricing-card">
          <div className="plan-badge monthly-badge">MONTHLY</div>
          <h3>⭐ Sergeant</h3>
          <div className="price">
            <span className="amount">$10</span>
            <span className="period">/month</span>
          </div>
          <ul className="features">
            <li>✓ Unlimited Surveys</li>
            <li>✓ Up to 50 Questions per Survey</li>
            <li>✓ No Time Limits</li>
            <li>✓ AI Survey Generation</li>
            <li>✓ AI Summary Reports</li>
            <li>✓ CSV Export</li>
            <li>✓ Advanced Analytics</li>
            <li>✓ Priority Support</li>
          </ul>
          <button 
            className="select-plan-btn"
            onClick={() => handleSelectPlan('sergeant')}
          >
            Select Sergeant
          </button>
        </div>
        
        {/* Lieutenant Plan */}
        <div className="pricing-card featured">
          <div className="best-value-badge">MOST POPULAR - 40% OFF</div>
          <h3>🏅 Lieutenant</h3>
          <div className="price">
            <span className="original-price">$95</span>
            <span className="amount">$57</span>
            <span className="period">/year</span>
          </div>
          <p className="savings">Save $63/year + Early Adopter Bonus!</p>
          <ul className="features">
            <li>✓ Unlimited Surveys</li>
            <li>✓ Up to 50 Questions per Survey</li>
            <li>✓ No Time Limits</li>
            <li>✓ AI Survey Generation</li>
            <li>✓ AI Summary Reports</li>
            <li>✓ CSV Export</li>
            <li>✓ Advanced Analytics</li>
            <li>✓ Priority Support</li>
            <li>✓ Annual Billing Discount</li>
          </ul>
          <button 
            className="select-plan-btn featured"
            onClick={() => handleSelectPlan('lieutenant')}
          >
            Select Lieutenant
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectPlan;
